<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="12" md="12">
            <v-tabs centered>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'Detailclass', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-text-box-check-outline</v-icon> Pengumuman
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'Detailclasswork', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-folder-text</v-icon> Tugas
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'Detailclasspeople', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Anggota
              </v-tab>
              <v-tab
                v-if="false"
                class="text-capitalize"
                :to="{ name: 'Detailclassgrade', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Nilai
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="12" v-if="alertdata.show">
            <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
          </v-col>
          <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </v-col>
          <v-col cols="12" md="12">
            <v-card
              outlined
              v-if="!loading.detail && detaildata.length > 0">
              <v-card-text>
                <v-row class="black--text">
                  <v-col cols="12" md="12">
                    <v-simple-table
                      fixed-header
                      height="65vh">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              Name
                            </th>
                            <th class="text-left">
                              Tugas 1
                            </th>
                            <th class="text-left">
                              Tugas 2
                            </th>
                            <th class="text-left">
                              Kuis
                            </th>
                            <th class="text-left">
                              UTS
                            </th>
                            <th class="text-left">
                              UAS
                            </th>
                            <th class="text-left">
                              Total
                            </th>
                            <th class="text-left">
                              Index
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in desserts"
                            :key="item.name">
                            <td>{{ item.name }}</td>
                            <td>{{ item.calories }}</td>
                            <td>{{ item.calories }}</td>
                            <td>{{ item.calories }}</td>
                            <td>{{ item.calories }}</td>
                            <td>{{ item.calories }}</td>
                            <td>{{ item.calories }}</td>
                            <td>{{ item.calories }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col cols="12" md="12">
                    <div class="mt-5 text-center">
                      <v-btn
                        class="mr-2 mb-2"
                        fab
                        depressed
                        dark
                        x-small
                        :to="{ name: 'Listclass' }">
                        <v-icon dark>
                          mdi-arrow-left-thick
                        </v-icon>
                      </v-btn>
                      <span class="title">Back to news list</span>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Detailclassgrade',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    detaildata: [],
    panduan: null,
    paramberita: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      berita: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    desserts: [
      {
        name: 'Student 1',
        calories: 80,
      },
      {
        name: 'Student 2',
        calories: 81,
      },
      {
        name: 'Student 3',
        calories: 80,
      },
      {
        name: 'Student 4',
        calories: 85,
      },
    ],
  }),
  watch: {
    '$route.query.berita'(val) {
      if (val) {
        this.check.berita = val;
        this.getBerita();
      }
    },
  },
  mounted() {
    if (this.$route.query.berita && this.$route.query.berita !== '') {
      this.check.berita = this.$route.query.berita;
      this.getBerita();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    getBerita() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.berita) {
        this.axios
          .get(
            this.api + '/api/kelas/teacher/' + this.check.berita,
            {
              params: this.paramberita,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Berita tidak ditemukan!';
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
